import React from "react";
import { useI18n } from "@core/i18n/i18n";
import NoTemplatesIcon from "@assets/icons/no-templates.svg";
import { useNavigate } from "@core/routing/use-navigate";
import { MessageContainer } from "@ui/components/common/message-container";
import { RoutesPath } from "@ui/navigation/routes";
import { AnalyticsProgramLocation, sendAnalyticsEventCreateProgram } from "@domain/program/program-analytics";

export const EmptyTemplates: React.FC = () => {
	const { format } = useI18n();
	const navigate = useNavigate();
	const sendAnalytics = () => sendAnalyticsEventCreateProgram(AnalyticsProgramLocation.PROGRAM_PAGE);

	return (
		<MessageContainer
			style={{ flexGrow: 1, padding: "72px 32px" }}
			iconSvg={NoTemplatesIcon}
			title={format("templateListing.noTemplates.title")}
			description={format("templateListing.noTemplates.description")}
			cta={{
				label: format("templateListing.createProgramButton"),
				onClick: () => {
					sendAnalytics();
					navigate(RoutesPath.TemplateBuilder);
				},
			}}
		/>
	);
};
